import React from "react"; 
import { Link } from "react-router-dom";    
import EditProductTypeForm from "../../../components/Dashboard/ProductTypesListContent/Edit";

const EditProductType = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Product Type</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Edit Product Type</li>
        </ul>
      </div> */}

      <EditProductTypeForm />
    </>
  );
};

export default EditProductType;
